angular.module('aprima-legacy-common').provider('AppRoutes', ['_', function(_){
    'use strict';

    var appRoutes = {
        findByStateName: findByStateName,
        // These functions are used in Angular but not AngularJS.
        findKeyByStateName: findKeyByStateName,
        getAppRoutes: getAppRoutes,
        setupAppRoutes: setupAppRoutes,
    };

    this.setupAppRoutes = setupAppRoutes;

    function findByStateName(stateName) {
        var appRoute = _.find(getAppRoutes(), {state: stateName});
        return appRoute;
    }

    function findKeyByStateName(stateName) {
        var appRoute = _.findKey(getAppRoutes(), {state: stateName});
        return appRoute;
    }

    function setupAppRoutes(newAppRoutes) {
        //does not overwrite existing properties
        _.defaults(appRoutes, newAppRoutes);
    }

    function getAppRoutes() {
        return appRoutes;
    }

    this.getAppRoutes = getAppRoutes;

    this.$get = [function(){
        return getAppRoutes();
    }];
}]);
